/**
 * Defines constant routes that might need to be referenced by many components.
 */

export interface Route {
  target?: string
  text?: string
  to: string
  rel?: string
}

export interface RouteWithCopy extends Route {
  text: string
}

export const ROUTES = {
  accountSettings: {
    to: '/settings/account',
  },
  about: {
    text: 'Our Story',
    to: '/g/about/',
  },
  beyondPlastic: {
    text: 'Move Beyond Plastic',
    to: '/beyondplastic/',
  },
  californiaSupplyChain: {
    text: 'CA Supply Chain Act',
    to: '/ca-supply-chain-act/',
  },
  careers: {
    text: "Careers (We're hiring!)",
    to: '/careers/',
  },
  cartRoute: {
    text: 'Your Cart',
    to: '/pantry/',
  },
  contactUs: {
    text: 'Contact Us',
    to: 'https://community.grove.co/hc/en-us/requests/new',
  },
  frequentlyAsked: {
    text: 'FAQ',
    target: '_blank',
    to: 'https://community.grove.co/hc/en-us/categories/200113215-FAQ/',
    rel: 'noopener',
  },
  groveStandard: {
    text: 'The Grove Standard',
    to: '/g/the-grove-standard/',
  },
  howGroveWorks: {
    text: 'How Grove Works',
    to: '/g/how-grove-works/',
  },
  howItWorks: {
    text: 'Get Started',
    to: '/how-it-works/',
  },
  inactiveRoute: {
    to: '/reactivate/',
  },
  loginRoute: {
    to: '/pantry-login/',
  },
  logoutRoute: {
    text: 'Log Out',
    to: '/logout/',
  },
  memberHome: {
    to: '/member/home/',
  },
  policies: {
    text: 'Policies & Disclosures',
    to: '/policies/',
  },
  privacy: {
    text: 'Privacy Policy',
    to: '/privacy/',
  },
  passwordReset: {
    to: '/accounts/password/reset/',
  },
  returns: {
    text: 'With free, easy returns',
    to: '/g/shipping-returns/',
  },
  subscriptions: {
    to: '/settings/subscriptions/',
  },
  terms: {
    text: 'Terms of Use',
    to: '/terms/',
  },
  vipHub: {
    to: '/vip-hub/',
  },
  visitorRoute: {
    to: '/',
  },
  wellnessRoute: {
    text: 'Meet Grove Wellness',
    to: '/g/wellness',
  },
}
